import { courseTypes } from '@/main.config.js'
import i18n from '@/i18n.js'

const courseTypeList = {
  [courseTypes.rehab]: {
    title: i18n.t('courseType.rehab'),
    shortTitle: i18n.t('courseType.rehabAbr'),
    description: i18n.t('courseType.rehabDescription')
  },
  [courseTypes.telemetry]: {
    title: i18n.t('courseType.telemetry'),
    shortTitle: i18n.t('courseType.telemetry'),
    description: i18n.t('courseType.telemetryDescription')
  }
}

const typesListForFilter = {
  ...courseTypeList,
  any: {
    title: i18n.t('courseStatus.any'),
    color: 'dark'
  }
}

export { courseTypeList, typesListForFilter }
